import { render, staticRenderFns } from "./invitePersonPlan.vue?vue&type=template&id=53615891&scoped=true"
import script from "./invitePersonPlan.vue?vue&type=script&lang=js"
export * from "./invitePersonPlan.vue?vue&type=script&lang=js"
import style0 from "./invitePersonPlan.vue?vue&type=style&index=0&id=53615891&prod&lang=scss&scoped=true"
import style1 from "./invitePersonPlan.vue?vue&type=style&index=1&id=53615891&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53615891",
  null
  
)

export default component.exports